import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Civilisation from "@/pages/Civilisation";
import Traditions from "@/pages/Traditions";
import TraditionDetail from "@/pages/TraditionDetail";
import Compare from "@/pages/Compare";
import Philosophy from "@/pages/Philosophy";
import Library from "@/pages/Library";
import Work from "@/pages/Work";
import Reader from "@/pages/Reader";
import Atlas from "@/pages/Atlas";
import Timelines from "@/pages/Timelines";
import Mandala from "@/pages/Mandala";
import CriticalStudies from "@/pages/CriticalStudies";
import Learn from "@/pages/Learn";
import Scholar from "@/pages/Scholar";
import SearchPage from "@/pages/Search";
import Account from "@/pages/Account";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import EditorialPage from "@/pages/EditorialPage";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <AuthProvider>
      <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#131B33", border: "1px solid #212D50", color: "#FDFBF7" } }} />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/civilisation" element={<Civilisation />} />
            <Route path="/traditions" element={<Traditions />} />
            <Route path="/traditions/:slug" element={<TraditionDetail />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/philosophy" element={<Philosophy />} />
            <Route path="/library" element={<Library />} />
            <Route path="/library/:slug" element={<Work />} />
            <Route path="/read/:id" element={<Reader />} />
            <Route path="/atlas" element={<Atlas />} />
            <Route path="/timelines" element={<Timelines />} />
            <Route path="/mandala" element={<Mandala />} />
            <Route path="/critical-studies" element={<CriticalStudies />} />
            <Route path="/learn" element={<Learn />} />
            <Route path="/scholar" element={<Scholar />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/account" element={<Account />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/about" element={<EditorialPage page="about" />} />
            <Route path="/sources" element={<EditorialPage page="sources" />} />
            <Route path="/editorial-policy" element={<EditorialPage page="editorial-policy" />} />
            <Route path="/contribute" element={<EditorialPage page="contribute" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
